<template>
  <div class="accessory-cost">
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item
          style="float: right; margin-right: 0 "
          v-if="funcView.accessory_cost_part_export"
        >
          <el-button
            class="table-set"
            @click="exportTable('giveawayCostsharePageExport',formSearch)"
          >
            <i class="icon icon-daochu"></i>
          </el-button>
        </el-form-item>

        <!-- 配置项 -->
        <el-form-item style="float: right;">
          <custom-column
           ref="column"
          ></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.bodyNum"
            :placeholder="$t('crm_costs.ji_shen_hao')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
         <el-form-item style="float: right">
          <switch-button :link="$refs.container"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 更多筛选 -->
    <switch-container ref="container" @search="onPageChange({ page: 1 })" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
         <el-form-item :label="$t('crm_costs.ztbgrq')">
          <custom-date-picker style="width: 100%" v-model="formSearch.stateChangeDate" type="daterange" align="right" value-format="YYYY-MM-DD HH:mm:ss" :picker-options="pickerOptionDisAfter"></custom-date-picker>
        </el-form-item>
        <el-form-item :label="$t('crm_costs.he_tong_bian_hao')">
          <el-input v-model="formSearch.contractNo" placeholder=""></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm_costs.shou_hou_gong_si')">
          <el-input v-model="formSearch.afterServiceName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item :label="$t('crm_costs.zeng_song_pei_jian')">
          <el-input style="width:100%;" v-model="formSearch.goodsName"></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        index
        v-if="funcView.accessory_cost_part_list"
        height="100%"
        :data="tableList"
        :column="tableColumn"
        :tableCode="tableCode"
        @filter="filterChange"
        @sort="sortChange"
        @column="setColumn"
        type="radio"
        :slots="['orderGoodsCode','contractNo','partSn','billTermNum','action']"
        >
        <template v-slot:orderGoodsCode="scope">
          <span
            class="cell-link"
            @click="showDetail(scope.row)"
          >{{ scope.row.orderGoodsCode }}</span>
        </template>
        <template v-slot:contractNo="scope">
          <div
            class="cell-link"
            @click="jump('/contractdetail', { contractId: scope.row.orderId, contractClass: scope.row.orderClass, parentPath: $route.path })"
          >
            {{ scope.row.contractNo }}
          </div>
        </template>
        <template v-slot:partSn="scope">
          <span>
            {{ scope.row.goodsCode || '-'}}/{{ scope.row.goodsName|| '-'}}
          </span>
        </template>
        <template v-slot:billTermNum="scope">
          <span>
            {{ scope.row.billTermNum || '-'}}/{{ scope.row.billTotalTerm|| '-'}}
          </span>
        </template>
          <!-- 操作 -->
          <template v-slot:action="scope">
            <el-button
                v-if="!scope.row.isAssignCost&&funcView.accessory_cost_part_edit"
                type="text"
                size="mini"
                @click="onEditCost(scope.row)"
              >
              {{ $t('crm_costs.bian_ji_cheng_ben') }}
              </el-button>
            <el-button
                v-if="scope.row.isAssignCost&&funcView.accessory_cost_part_info"
                type="text"
                size="mini"
                @click="onViewCost(scope.row)"
              >
              {{ $t('crm_costs.fen_tan_xiang_qing') }}
              </el-button>
          </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <part-order-detail-dialog
      v-if="detailVisible"
      @close="detailVisible = false"
      :model="detailModel"
      @infoChange="getTableList"
    ></part-order-detail-dialog>
    <edit-cost-dialog
      v-if="dialogVisible1"
      @close="dialogVisible1 = false"
      @success="onPageChange({ page: 1 })"
      :model="dialogModel1"
    ></edit-cost-dialog>
    <accessoryCost-detail-dialog
      v-if="dialogVisible2"
      @close="dialogVisible2 = false"
      @success="onPageChange({ page: 1 })"
      :model="dialogModel2"
    ></accessoryCost-detail-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins.js';
import partOrderDetailDialog from '@/pages/crm/components/part_order_detail_dialog.vue';
import editCostDialog from './edit_cost_dialog.vue';
import accessoryCostDetailDialog from './accessoryCost_detail_dialog.vue';


export default {
  name: '',
  mixins: [resetFormSearchMixins],
  components: {
    editCostDialog,
    partOrderDetailDialog,
    accessoryCostDetailDialog
  },
  props: {},
  data() {
    return {
      tableCode: 'accessory_cost',
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        orderType: '',
        orderBy: '',
        bodyNum: '',
        stateChangeDate: [],
        contractNo: '',
        afterServiceName: '',
        goodsName: ''
      },
      tableList: [],
      totalRows: null,

      // 配送订单详情
      detailVisible: false,
      detailModel: {},
      // 编辑成本
      dialogVisible1: false,
      dialogModel1: {},
      // 分摊详情
      dialogVisible2: false,
      dialogModel2: {},
    };
  },
  computed: {},
  watch: {},
  filters: {},
  directives: {},
  methods: {
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    getTableList() {
      this.$getJSON(apis.giveawayCostsharePage, this.formSearch).then((res) => {
        this.tableList = res.data.records;
        this.totalRows = res.data.total;
      });
    },
    // 申请翻新
    onEditCost(row) {
      this.dialogModel1 = {
        data: row,
        type: 'edit',
        title: this.$t('crm_costs.bian_ji_cheng_ben')
      };
      this.dialogVisible1 = true;
    },
    onViewCost(row) {
      this.dialogModel2 = {
        data: row,
        type: 'detail',
        title: this.$t('crm_costs.fen_tan_xiang_qingo', [row.bodyNum])
      };
      this.dialogVisible2 = true;
    },
    // 配送订单详情
    showDetail(row) {
      this.detailModel = {
        title: row.orderGoodsCode,
        data: row,
      };
      this.detailVisible = true;
    },
  },
  created() { },
  mounted() {
    this.resetFormSearch = JSON.stringify(this.formSearch);
    this.getFuncView();
    this.getTableList();

  },
};
</script>

<style lang="scss" scoped>
.accessory-cost {
  flex: 1;
  display: flex;
  padding-left: 16px;
  flex-direction: column;
  overflow: hidden;
}
</style>
